var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.484,
    height: 18.143,
    viewBox: "0 0 12.484 18.143"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-download_svg__cls-1{fill:none;stroke:#119aeb;stroke-linecap:round;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-download_svg__ICN_Descarca_Doument_Enabled",
    "data-name": "ICN_Descarca Doument_Enabled",
    transform: "translate(1.131 .8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-download_svg__Line_78",
    "data-name": "Line 78",
    className: "kpmg-download_svg__cls-1",
    d: "M0 0h10.221"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-download_svg__Group_701",
    "data-name": "Group 701",
    transform: "translate(0 5.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-download_svg__Line_79",
    "data-name": "Line 79",
    className: "kpmg-download_svg__cls-1",
    transform: "translate(5.11)",
    d: "M0 11.101V0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-download_svg__Line_80",
    "data-name": "Line 80",
    className: "kpmg-download_svg__cls-1",
    transform: "translate(0 5.99)",
    d: "M5.11 5.11L0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-download_svg__Line_81",
    "data-name": "Line 81",
    className: "kpmg-download_svg__cls-1",
    transform: "translate(5.11 5.99)",
    d: "M0 5.11L5.11 0"
  })))));
}

export default SvgKpmgDownload;